<template>

  <main class="content" v-if="typeof fusebox.uuid !== 'undefined'">
    <div class="content__heading content__heading--navigation">
      <h1>
        <i class="icon--list"></i> {{ fusebox.name }}
        <small v-if="typeof fusebox.location !== 'undefined'">({{ fusebox.location.address }})</small>
      </h1>

      <nav v-if="isNotGuest" class="navigation--buttonGroup">
        <button @click="downloadPdf">
          <i class="icon--pdf"></i>
        </button>
        <button v-if="$can('email_pdf_client', 'plans')" @click=sendEmail(fusebox.pre_email_body)><i
          class="icon--email"></i></button>
        <button @click="showFuseboxModal"><i class="icon--edit"></i></button>
        <button @click="$modal.show('confirmation', { id: $route.params.id })"><i class="icon--delete"></i></button>

      </nav>
    </div>

    <section class="fusebox">
      <div class="fusebox__grid">

        <div class="fusebox__grid__row">
          <div class="fusebox__grid__cell">

            <div class="fusebox__grid__cell--boxed">
              <div class="fusebox__grid__cell__heading">
                <h2><i class="icon--groups"></i> {{ $t('fusebox.groups') }} <small
                  :v-if="fuseboxGroups !== 'undefined'"> ({{ fuseboxGroups.length }})</small></h2>
              </div>

              <div class="table table--badged" v-if="fuseboxGroups.length > 0">

                <div class="table--badged__row" v-for="(fuseboxGroup, index) in fuseboxGroups" :key="fuseboxGroup.uuid">

                  <div class="table--badged__badge table--badged__badge--light">
                    <div class="table--badged__badge--clipped">
                      {{ fuseboxGroup.order_no }}
                    </div>
                  </div>
                  <div class="table--badged__description" :class="{'table--badged__description--full': !isNotGuest}">
                    <h3>
                      {{ fuseboxGroup.name }}
                    </h3>
                    <small>
                      <span class="table--badged__description__item">
                        <i class="icon--current"></i> {{ fuseboxGroup.phase === 0 ? $t('general.1phase') : $t('general.3phase') }}</span>
                      <span class="table--badged__description__item" v-if="fuseboxGroup.amperage"><i
                        class="icon--bulb"></i> {{ fuseboxGroup.amperage }}
                      </span>
                      <span class="table--badged__description__item" v-if="fuseboxGroup.characteristic"><i
                        class="icon--char"></i> {{
                        $t('general.characteristic', {char: fuseboxGroup.characteristic}) }}
                      </span>
                    </small>
                  </div>
                  <div v-if="isNotGuest" class="navigation--buttonGroup navigation--buttonGroup--table">
                    <button @click="prepEdit(fuseboxGroup)"><i class="icon--edit"></i></button>
                    <button class="btn--info" @click="showAdditional(fuseboxGroup, index)"
                            v-tooltip.bottom-start="{ content: fuseboxGroup.additional_info, classes: ['testing'], trigger: 'hover'}">
                      <i class="icon--info"></i></button>
                    <button @click="$modal.show('group-confirm', { groupId: fuseboxGroup.uuid, index })"><i
                      class="icon--delete"></i></button>
                  </div>
                </div>

              </div>
              <div class="message" v-if="fuseboxGroups.length === 0 && isNotGuest">
                {{ $t('messages.noGroups') }}
              </div>

              <div class="btn--bar">
                <button v-if="isNotGuest" @click="show()" type="button" class="btn btn">
                  <i class="icon--plus"></i> {{ $t('fusebox.add_group') }}
                </button>
                <button v-if="fuseboxGroups.length !== 0 && isNotGuest" @click="downloadPdf" type="button"
                        class="btn btn--secondary">
                  <i class="icon--pdf"></i> {{ $t('fusebox.download') }}
                </button>

                <button
                  v-else-if="isAuth && $can('request_access', 'plans') && fusebox.managed_by !== user.company.id && fusebox.is_personal"
                  @click="$modal.show('access-confirm', { id: fusebox.uuid })"
                  type="button" class="btn btn--center">{{
                  $t('fusebox.request_to_access') }}
                </button>
                <button v-if="!isAuth" @click="$router.replace({ name: 'auth.login', query: {intended: $route.path} })"
                        type="button" class="btn btn--center">{{
                  $t('fusebox.login_to_edit') }}
                </button>
              </div>
            </div>
            <div class="fusebox__grid__cell--boxed" v-if="isNotGuest">
              <div class="fusebox__grid__cell__heading">
                <h2><i class="icon--history"></i> {{ $t('general.history') }}
                  <small>({{ $t('fusebox.lastNth', {
                    historyItems: history.length > historyItems ? historyItems : history.length })
                    }})</small></h2>
              </div>

              <div class="table table--badged" v-if="history.length">

                <div class="table--badged__row" v-for="(hist, i) in history.slice(0, historyItems)" :key="i">

                  <div class="table--badged__badge" :data-icon="hist.description"></div>
                  <div class="table--badged__description table--badged__description--full">
                    <h3>
                      {{ $t(`fusebox.history.${hist.description.toLowerCase()}`) }}
                      <span
                        v-if="hist.description.toLowerCase() != historyScan">(#{{ hist.properties.order_no }})</span>
                    </h3>
                    <small>
                      <span class="table--badged__description__item table--badged__description__item--1/2"
                            v-if="hist.created_at"><i
                        class="icon--calendar"></i> {{ hist.created_at | moment('MMM D YYYY, HH:mm') }}</span>
                      <span class="table--badged__description__item table--badged__description__item--1/2"
                            v-if="hist.causer_id !== null"><i
                        class="icon--user"></i> {{ hist.name }}</span>
                    </small>
                  </div>
                </div>

              </div>
              <div class="message" v-else>
                {{ $t('messages.noHistory') }}
              </div>

            </div>

            <div class="fusebox__grid__cell--boxed" v-if="showPartners">
              <div class="fusebox__grid__cell__heading">
                <h2><i class="icon--users"></i> {{ $t('fusebox.partners') }}</h2>
              </div>
              <div class="table table--badged">

                <div class="table--badged__row" v-for="(partner) in fusebox.partners" :key="partner.uuid">

                  <div class="table--badged__badge table--badged__badge--light"><img :src="partner.logo"/></div>
                  <div class="table--badged__description">
                    <h5 class="partner--heading">{{ partner.name }}</h5>
                    <span class="partner--details">
                        <i class="icon--location"></i> {{ partner.address }}
                      </span>
                    <span class="partner--details"><i
                      class="icon--phone"></i> {{ partner.mobile }}
                      </span>
                    <span class="partner--details"><i
                      class="icon--location"></i> {{ partner.distance }}
                      </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div v-if="isNotGuest" class="fusebox__grid__cell">

            <div class="fusebox__grid__cell--boxed">
              <div class="fusebox__grid__cell__heading">
                <h2><i class="icon--info"></i> {{ $t('fusebox.details') }}</h2>
              </div>

              <h3>{{ $t('fusebox.general_details') }}:</h3>

              <ul class="list list--details">
                <li class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.form.name') }}</div>
                  <div class="list--details__value">{{ fusebox.name }}</div>
                </li>
                <li class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.form.location') }}</div>
                  <div class="list--details__value">
                    {{ typeof fusebox.location !== 'undefined' ?
                    [[fusebox.location.address,
                    fusebox.location.no].join(' '),
                    [fusebox.location.zip,
                    fusebox.location.city].join(' ')].join(', ') : '' }}
                  </div>
                </li>
                <li class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.group_count') }}</div>
                  <div class="list--details__value">{{ fuseboxGroups.length }}</div>
                </li>
                <li class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.last_updated') }}</div>
                  <div class="list--details__value">{{ fusebox.last_modified_at | moment('D MMMM YYYY') }}</div>
                </li>
                <li v-if="$can('view', 'labels')" class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.form.labels') }}</div>
                  <div class="list--details__value list--details__value--multiline">
                    <div v-for="label in fusebox.labels" :key="label" class="label">
                      {{ label }}
                    </div>
                  </div>
                </li>
                <li class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.energy_provider') }}</div>
                  <div class="list--details__value">{{ typeof fusebox.energy_provider !== 'undefined' &&
                    fusebox.energy_provider !== null ? fusebox.energy_provider.name : '-' }}
                  </div>
                </li>
                <li class="list list--details__item">
                  <div class="list--details__key">{{ $t('fusebox.network_operator') }}</div>
                  <div class="list--details__value">{{ typeof fusebox.network_operator !== 'undefined' &&
                    fusebox.network_operator !== null ? fusebox.network_operator.name : '-' }}
                  </div>
                </li>
              </ul>

              <div class="btn--bar">
                <button v-if="isNotGuest" @click="showFuseboxModal" type="button" class="btn btn--center">
                  <i class="icon--edit"></i> {{ $t('fusebox.edit') }}
                </button>

              </div>

            </div>

            <div v-if="isNotGuest" class="fusebox__grid__cell--boxed">
              <div class="fusebox__grid__cell__heading">
                <h2><i class="icon--images"></i> {{ $t('fusebox.images') }} <small>({{ this.fusebox.images.length
                  }})</small></h2>
              </div>

              <div class="message" v-if="fusebox.images.length == 0">
                {{ $t('messages.noImages') }}
              </div>

              <div class="uploadbox__uploaded" v-if="fusebox.images.length > 0">
                <figure v-for="(image, index) in fusebox.images" @click="openLightbox(image.full_path)" :key="image.id"
                        class="uploadbox__image">
                  <img :src="image.path"/>
                  <button @click.stop="deleteImage(image, index)" type="button"><i
                    class="icon--delete"></i></button>
                </figure>
              </div>
              <div class="uploadbox__dropzone">
                <vue-dropzone
                  id="dropzone"
                  @vdropzone-success="uploadedEvent"
                  @vdropzone-sending="sendingEvent"
                  :options="dropzoneOptions"
                  :useCustomSlot=true
                  ref="imageDropzone">
                  <div class="dropzone">
                    <i class="icon--upload"></i> {{ $t('fusebox.add_new_images') }}
                  </div>
                </vue-dropzone>
              </div>

            </div>

            <div v-if="typeof user.company !== 'undefined' && user.company !== null" class="fusebox__grid__cell--boxed">
              <div class="fusebox__grid__cell__heading">
                <h2><i class="icon--qr"></i> {{ $t('fusebox.qr_code') }}</h2>
              </div>

              <div class="qr" ref="qrCode"></div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <ModalGroup @change-date="changeDate"
                @hideModal="hide()"
                @clearEdit="clearEdit"
                :edit="edit"
                :amperages="amperages"
                :characteristics="characteristics"/>
    <ModalFuseboxEmail :pre-email-body="preEmailBody" :owner="fusebox.owner" @hideModal="hideEmailModal()"/>
    <AddFusebox v-if="isNotGuest" @hideModal="hideFuseboxModal" :edit="fusebox" @init="initFB"/>
    <Lightbox :url="currentImage" @hideModal="closeLightbox"/>
    <Confirm @confirmed="remove"/>
    <Confirm name="group-confirm" @confirmed="deleteGroup"/>
    <Confirm action-key="general.request" @confirmed="accessRequest" name="access-confirm" title="general.request_title"
             body="general.request_body_company"/>

  </main>
  <main v-else-if="initialized" class="content">
    <section class="fusebox">
      <div class="fusebox__grid">
        <div class="fusebox__grid__row">
          <div class="fusebox__grid__full">
            <div class="fusebox__grid__cell__heading">
              <h2><i class="icon--list"></i> {{ $t('messages.noFuseboxTitle') }}</h2>
            </div>
            <div>
              {{ $t('messages.noFusebox') }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import qrcode from 'qrcode-generator'
import { FUSEBOX_IMAGES, HISTORY, SHORT_FUSEBOX_URL } from '@/constants'
import vue2Dropzone from 'vue2-dropzone'
import { mapGetters } from 'vuex'
import ModalGroup from '@/components/Modal/Group'
import { errHandler } from '@/helpers'
import ModalFuseboxEmail from '@/components/Modal/FuseboxEmail'
import AddFusebox from '@/components/Modal/AddFusebox'
import Lightbox from '@/components/Modal/Lightbox'
import Confirm from '@/components/Modal/Confirm'

export default {
  name: 'Fusebox-Id-Index',
  components: {
    Confirm,
    Lightbox,
    AddFusebox,
    ModalFuseboxEmail,
    ModalGroup,
    vueDropzone: vue2Dropzone
  },
  beforeMount () {
    this.$store.commit('loader/startIntLoading')
  },
  data () {
    return {
      currentImage: '',
      initialized: false,
      historyItems: 5,
      amperages: [],
      characteristics: [],
      dropzoneOptions: {
        url: FUSEBOX_IMAGES.UPLOAD_URL,
        parallelUploads: FUSEBOX_IMAGES.MAX_FILES,
        maxFilesize: FUSEBOX_IMAGES.MAXIMUM_FILE_SIZE || 2,
        uploadMultiple: true,
        thumbnailWidth: 150,
        thumbnailMethod: 'contain',
        addRemoveLinks: true,
        acceptedFiles: 'image/*',
        maxFiles: FUSEBOX_IMAGES.MAX_FILES,
        dictFileTooBig: 'File is too big. Max 10MB.',
        headers: { 'Authorization': 'Bearer ' + this.$store.state.auth.token }
      },
      edit: false,
      submit: false,
      preEmailBody: '',
      historyScan: HISTORY.SCANNED
    }
  },
  async mounted () {
    await this.initFB()
    this.init()
  },
  computed: {
    ...mapGetters('fusebox', {
      fusebox: 'single',
      history: 'history',
      fuseboxGroups: 'fuseboxGroupList'
    }),
    getRoutePath () {
      return this.$route.path
    },
    isNotGuest () {
      return !this.$route.meta.public
    },
    showPartners () {
      return this.fusebox.managed_by === null &&
        this.fusebox.is_personal === true &&
        typeof this.fusebox.partners !== 'undefined' &&
        this.fusebox.partners.length > 0
    }
  },
  methods: {
    async initFB () {
      try {
        await this.$store.dispatch('fusebox/show', {
          id: this.$route.params.id,
          public: !this.isNotGuest
        })
      } catch (e) {
        // EMPTY
      }
    },
    openLightbox (url) {
      this.currentImage = url
      this.$modal.show('lightbox')
    },
    closeLightbox () {
      this.currentImage = ''
      this.$modal.hide('lightbox')
    },
    clearEdit () {
      this.edit = false
    },
    prepEdit (item) {
      this.edit = item
      this.show()
    },
    sendEmail (item) {
      if (this.$can('email_pdf_client', 'plans')) {
        this.preEmailBody = item
        this.showEmailModal()
      }
    },
    sendingEvent (file, xhr, formData) {
      formData.append('fusebox_id', this.fusebox.uuid)
    },
    uploadedEvent (file, { data }) {
      setTimeout(() => {
        this.$store.commit('fusebox/setSingle', data)
      }, 500)
      this.$refs.imageDropzone.removeAllFiles()
    },
    show () {
      this.$modal.show('add-fusebox-group')
    },
    hide () {
      this.$modal.hide('add-fusebox-group')
    },
    showEmailModal () {
      this.$modal.show('send-email')
    },
    hideEmailModal () {
      this.$modal.hide('send-email')
    },
    showFuseboxModal () {
      this.$modal.show('Fusebox-Group')
    },
    hideFuseboxModal () {
      this.$modal.hide('Fusebox-Group')
    },
    async init () {
      try {
        const { amperages, characteristics, activity } = await this.$store.dispatch('fusebox/initGroup', {
          id: this.$route.params.id,
          public: !this.isNotGuest
        })
        this.amperages = amperages
        this.characteristics = characteristics
        this.$store.commit('fusebox/setHistory', activity)
      } catch (e) {
        // EMPTY
      } finally {
        this.initialized = true
        this.$store.dispatch('loader/stopIntLoading')
      }
    },
    async deleteImage (image, index) {
      try {
        await this.$store.dispatch('fusebox/deleteImage', {
          id: this.$route.params.id,
          imageId: image.id,
          indexId: index
        })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    changeDate () {
      this.$store.commit('fusebox/changeSingleDate', new Date())
    },
    showAdditional (fuseboxGroup, index) {
      const newList = [...this.fuseboxGroups]
      newList[index].show = !newList[index].show
      this.$store.commit('fusebox/setFuseboxGroupList', newList)
    },
    async deleteGroup ({ groupId, index }) {
      if (this.submit) { return false }
      try {
        this.submit = true
        await this.$store.dispatch('fusebox/deleteGroup', {
          id: this.$route.params.id,
          group_id: groupId,
          index
        })
        this.$modal.hide('group-confirm')
        this.changeDate()
        this.$toasted.global.success_message({
          message: this.$t('fusebox.deleteGroupSuccess')
        })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.submit = false
      }
    },
    async remove ({ id }) {
      try {
        await this.$store.dispatch('fusebox/delete', id)
        this.init()
        this.$toasted.global.success_message({
          message: this.$t('fusebox.deleteSuccess')
        })
        this.$modal.hide('confirmation')
        this.$router.push({ name: 'fusebox.index' })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async downloadPdf () {
      try {
        const data = await this.$store.dispatch('fusebox/pdfGenerate', this.fusebox.qr_code)
        this.init()
        const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${this.fusebox.name}.pdf`)
        document.body.appendChild(link)
        link.click()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async accessRequest ({ id }) {
      try {
        await this.$store.dispatch('fusebox/requestAccess', id)
        this.$toasted.global.success_message({
          message: this.$t('fusebox.requestSentSuccessfully')
        })
        this.$modal.hide('access-confirm')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    }
  },
  watch: {
    fusebox (val) {
      if (typeof val.short_code !== 'undefined' && this.isNotGuest) {
        this.$nextTick(() => {
          let qr = qrcode(0, 'L')
          qr.addData(`${SHORT_FUSEBOX_URL}${val.short_code}`)
          qr.make()
          this.$refs.qrCode.innerHTML = qr.createSvgTag(3.5, 0)
        })
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('fusebox/clearFusebox')
  }
}
</script>
